export default {
    title: 'Cloud Server',
    cloud_server: 'Cloud Server',
    service_package: 'Service Package',
    invoice_id: 'Invoice ID',
    machine_name: 'Machine Name',
    reg_date: 'Reg Date',
    due_date: 'Exp Date',
    enable_backup: 'Enable Backup',
    server_status: 'Server Status',
    server_package_status: 'Package Status',
    server_name: 'Server name',
    project_name: 'Project name',
    package_status: 'Package status',
    package_name: 'Package name',
    specifications: 'Specifications',
    ip: 'Public IP',
    username: 'Username',
    password: 'Password',
    cloud_server_detail: 'Cloud Server Detail',
    dashboard: 'Dashboard',
    cloud_server_info: 'Cloud Server Information',
    order_code: 'Order code',
    info_management_server: 'Information Management Server',
    start: 'Start',
    restart: 'Restart',
    shutdown: 'Shutdown',
    console: 'Console',
    change_os: 'Change/ Reinstall Operating System',
    change_os_alert:
        "Warning: If you do this, the Backup Cloud function will be turned off, and this cloud server won't be able to use the restore feature for old backup files. Those old backup files could be used to make new clouds. Are you sure you want to continue?",
    type_os: 'Type of operating system',
    version: 'Version',
    new_password: 'New Password',
    extend_cloud_server: 'Extend Cloud Server',
    additional_ip: 'Additional IP',
    additional_storage: 'Additional Storage',
    payment_plan: 'Payment Plan',
    cloud_server_change_os_failed:
        'Cloud Configuration Failure. Please try again.',
    auto_renew: 'Auto Renew',
    terminal_username: 'Terminal Username',
    credentials: 'Credentials',
    upgrade_cloud_server: 'Upgrade Cloud Server',
    upgrade_warning:
        'You need to pay this order within the day, otherwise the order will be deleted',
    change_password: 'Change Cloud Server Password',
    change_password_notice: {
        1: 'Important Notice: You are about to change the password for your Cloud Server.',
        2: 'We want to inform you that this process will result in the loss of data in your user directory (e.g., {ubuntuUserDir} on Ubuntu or {windowsUserDir} on Windows).',
        3: 'We assure the certainty of this notification and appreciate your cooperation. Thank you!',
    },
    backup_name: 'Backup name',
    restore_cloud_server: {
        title: 'Restore Cloud Server',
        confirm_title:
            'Do you want to restore {packageName} from {backupName}?',
        confirm_des:
            'This operation will overwrite the server data by using the following backup. One started, the restoration cannot be canceled.',
    },
    disable_backup: {
        title: 'Disable Backup',
        confirm_title: 'Do you want to disable backup?',
    },
    backup_list: {
        history_backup: 'History Backup',
        backup_name: 'Backup Name',
        created_date: 'Created Date',
    },
    schedule_backup: 'Schedule Backup',
    schedule_displayed: 'Backups are scheduled to start',
    cron_expression: 'Cron expression',
    cron_run_at: 'Your cron job will be run at',
    backup_will_be_enabled: 'Backup will be enabled',
    backup_management: {
        title: 'Backup Management Server',
        enable_backup: {
            title: "Let's start backing up your Cloud Server",
            description:
                'Backups automatically create weekly copies of your Cloud Server.{lineBreak}They can be used for restoring lost or corrupt data and creating new Cloud Server.',
            description_price:
                'Backups for this Cloud Server cost {price}/times.',
        },
        disable_backup: {
            title: 'Backups are currently enabled',
            description:
                'They are retained at most {numberOfCopies} and can be restored for further use.',
            description_price:
                'Backups for this Cloud Server cost {price}/times.',
        },
    },
    cloud_addons: {
        cpu: 'vCPU',
        ram: 'Ram',
        storage: 'Storage',
        bandwidth: 'Bandwidth',
        os: 'OS',
    },
    cores: 'cores',
};
